/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Tier_2_DInputs */

const en_cp_tier_2_d = /** @type {(inputs: Cp_Tier_2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`≥ 2 build nights, ≥ 1 active class/community (≥ 10 teams), ≥ 1 team in the Build Challenge. Club credits ×2, certificate, recommendation, judge invitation.`)
};

const id_cp_tier_2_d = /** @type {(inputs: Cp_Tier_2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`≥ 2 build night, ≥ 1 kelas/komunitas aktif (≥ 10 tim), ≥ 1 tim ikut Build Challenge. Kredit klub ×2, sertifikat, rekomendasi, undangan juri.`)
};

/**
* | output |
* | --- |
* | "≥ 2 build nights, ≥ 1 active class/community (≥ 10 teams), ≥ 1 team in the Build Challenge. Club credits ×2, certificate, recommendation, judge invitation." |
*
* @param {Cp_Tier_2_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_tier_2_d = /** @type {((inputs?: Cp_Tier_2_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Tier_2_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_tier_2_d(inputs)
	return en_cp_tier_2_d(inputs)
});